import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

export const getBracket = (
  salary: number,
  brackets: { maxSalary: number }[],
) => {
  const sorted = brackets.sort((a, b) => a.maxSalary - b.maxSalary);

  const matched = sorted.find((b) => salary <= b.maxSalary);

  return matched || null;
};

export const formatTime = (timeStr: string, isRtl: boolean) => {
  if (!timeStr) return "";
  const [hour, minute] = timeStr.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return format(date, "hh:mm a", { locale: isRtl ? ar : enUS });
};

export const formatDate = (dateStr: string, isRtl: boolean) => {
  if (!dateStr) return "";
  return format(new Date(dateStr), "dd MMMM yyyy", {
    locale: isRtl ? ar : enUS,
  });
};
